import { t } from 'i18next';

import { ErrorResponseErrorItemCodeOrthotile } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeOrthotile, string> => ({
  'orthotile:not_found_in_project': t('orthotile.notFoundInProject', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ortobilden hittades inte i projektet.',
  }),
});
